@if (error(); as error) {
  <nk-error-alert [error]="error"></nk-error-alert>
}
@if (data$ | async; as data) {
  <h6 class="font-weight-bold">{{ 'tables.screening_adverse_media.header' | translate }}</h6>
  @if (isLoading()) {
    <nk-progress [isLoading]="true"></nk-progress>
  } @else if (data.entities.length === 0) {
    <p class="text-muted">{{ 'tables.screening_adverse_media.no_data_found' | translate }}</p>
  } @else {
    @for (item of data.entities; track item.uuid) {
      <nk-card [dense]="true">
        <nk-card-content class="text-small border rounded">
          <p class="small text-muted my-1 d-flex align-items-start justify-content-between">
            <span class="text-muted">{{ item.publishingDate | date: dateFormats.Standard }}</span>
            <span>
              {{ 'tables.screening_adverse_media.match_name' | translate }}: {{ item.matchName | normalCase }}
              <br />
              {{ 'tables.screening_adverse_media.match_score' | translate }}: {{ item.matchScore | number: '1.0-2' }}
            </span>
          </p>
          <h5 [innerHTML]="item.title | highlightText: item.highlightTexts : 'highlightText highlightText-yellow'"></h5>
          <p [innerHTML]="item.snippet | highlightText: item.highlightTexts : 'highlightText highlightText-yellow'"></p>
          <div class="d-flex justify-content-between align-items-start">
            <a href="{{ item.url }}" target="_blank"> <i class="me-1 fa fa-external-link"></i> {{ item.url }} </a>
          </div>
        </nk-card-content>
      </nk-card>
    }
    @if (printVersion() && data.pagination.totalCount > printLimit) {
      <div class="alert alert-info mt-2">
        <h6 class="mb-0">
          {{ 'common.print_limit_exceeded' | translate: { limit: printLimit, totalCount: data.pagination.totalCount } }}
        </h6>
      </div>
    }
    @if (!printVersion() && data.pagination.totalCount > data.pagination.limit) {
      <div class="row card-list-pagination">
        <div class="col-4 d-flex align-items-center">
          <span class="text-muted">
            {{ 'common.pagination.total_count' | translate: { totalCount: data.pagination.totalCount } }}
          </span>
        </div>
        <div class="col-8 d-flex justify-content-end">
          <nk-pagination
            [currentPage]="data.pagination.page"
            [totalItems]="data.pagination.totalCount"
            [itemsPerPage]="data.pagination.limit"
            [maxSize]="3"
            (changePage)="onChangePage($event)"></nk-pagination>
        </div>
      </div>
    }
    <hr />
  }
} @else {
  <nk-progress [isLoading]="true"></nk-progress>
}
